import "./style.scss"

import 'master';

$(function() {
 
    if ($('.box-filtering #type').length > 0) {
        var currectFilterType = getUrlParameter('type');
        var curSportType = getUrlParameter('sports');

        if (currectFilterType) {
            $('.box-filtering #type option[id=' + currectFilterType + ']').prop("selected", true);

            if (currectFilterType == 'Sports') {
            $('.event-top-bar').addClass('displayChild');

            if (curSportType) {
                $('.box-filtering #sportsTag option[id=' + curSportType + ']').prop("selected", true);
            }

            ;
            }
        }

        $('.box-filtering #type, .box-filtering #sportsTag').bind('change', function () {
            window.location = $(this).val();
        });
    }

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.href);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, '    '));
    }
});